import { FaPlay, FaPause, FaFastBackward, FaFastForward } from "react-icons/fa";
import { MdOutlineForward10, MdReplay10 } from "react-icons/md";

const VideoControls = ({
  isPlaying = false,
  toggleplay,
  onSeek,
  currentTime = 0,
  duration = 0,
  onPrevEvent,
  onNextEvent,
  handleDownload,
}) => {
  return (
    <div className="controls-wrapper">
      <button className="btn btn-light" onClick={onPrevEvent}>
        ⬅️ Prev Event
      </button>
      <button className="btn btn-light" onClick={() => onSeek(Math.max(currentTime - 10))}>
        <MdReplay10 />
      </button>
      <button className="btn btn-light" onClick={() => onSeek(0)}>
        <FaFastBackward />
      </button>
      <button className="btn btn-light" onClick={toggleplay}>
        {isPlaying ? <FaPause /> : <FaPlay />}
      </button>
      <button className="btn btn-light" onClick={() => onSeek(duration)}>
        <FaFastForward />
      </button>
      <button className="btn btn-light" onClick={() => onSeek(Math.min(currentTime + 10))}>
        <MdOutlineForward10 />
      </button>
      <button className="btn btn-light" onClick={onNextEvent}>
        ➡️ Next Event
      </button>
      <button className="btn btn-light" onClick={handleDownload}>
        ⬇️
      </button>
    </div>
  );
};

export default VideoControls;
